import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Iconify, TaskDatePick, UserAvatar } from "src/components";
import "./css/style.css";
import TaskComment from "./TaskComment";
import PriorityButton from "./components/PriorityButton";
import StatusButton from "./components/StatusButton";
import { useSnackbar } from "notistack";
import {
  _edit_task,
  _mark_task_comment_as_read,
  _update_task_files,
  _upload_file,
} from "src/DAL";
import MembersButton from "./components/MembersButton";
import LabelDialog from "./components/LabelDialog";
import { FILE_ACCEPT_TYPE_STRING } from "src/constants";
import { truncateText, replacedText } from "src/utils";
import CheckList from "./components/CheckList";
import {
  _add_task_attachments,
  _delete_task_attachments,
  _rename_task_attachments,
  _task_detail,
} from "src/DAL/taskDetailDrawer";
import CheckListItem from "./components/CheckListItem";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useAppContext, useMentions } from "src/hooks";
import { useDropzone } from "react-dropzone";
import { capitalCase } from "change-case";
import { string_with_limited_length } from "src/utils/common";
import TimeBlock from "./components/TimeBlock";
import Timer from "./components/Timer";
import PlannedTimeInput from "./components/PlannedTimeInput";
import NotifySelectedUser from "./components/NotifySelectedUser";
import MuiAutoCompleteTimes from "../MuiAutoCompleteTimes";
import Activity from "./components/Activity";
import RecurringEventDialog from "src/pages/task-calendar/components/RecurringEventDialog";
import ReportTaskIssueDialog from "./components/ReportTaskIssueDialog";
import { ALL_FILES_TYPES_WITH_ICONS } from "src/constants/constants";
import TaskAttachments from "./components/TaskAttachments";
import ImprovementDialog from "./components/FeedbackDialog";
import MentionMemoEditor from "./components/MentionMemoEditor";
import ReplyComment from "./components/ReplyComment";
import MentionDetailPopover from "./components/MentionDetailPopover";

const useStyles = makeStyles({
  topScrollPaper: {
    alignItems: "flex-start",
    zIndex: 1100,
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
});

function TaskDetailDialog({
  task,
  open,
  onClose,
  projectTeam,
  taskFiles,
  projectTags,
  setProjectTags,
  onChangeTags,
  handleNavigate,
  setTask,
  getFileIconType,
  onChangePriority,
  onChangeStatus,
  onChangeMembers,
  handleSendComment,
  newComment,
  setNewComment,
  onDelComment,
  editCommentTitle,
  setEditCommentTitle,
  onEditComment,
  handleUpdateTaskComment,
  editingCommentId,
  setEditingCommentId,
  setTasks = () => {},
  getFilteredTasksBySection = () => {},
  onChangeDate,
  getListing = null,
  addCommentLoading,
  sections = [],
  canMoveTask = false,
  onMovetoWorkspace,
  taskDetailLoading = false,
  setTaskDetailLoading = () => {},
  onDelTask = () => {},
  getFilteredSections, // passed to timer
  loadingMember,
  handleReplyComment = () => {},
}) {
  const is_mobile_view = useMediaQuery("(max-width:600px)");
  const nodeListRef = useRef();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { dispatch_get_user_profile } = useAppContext();
  const userId = dispatch_get_user_profile().user_id;
  let textareaRef = useRef(null);
  const editorRef = useRef(null);
  const commentsRef = useRef(null); // Ref for scrolling to comments section
  const [taskTitle, setTaskTitle] = useState(task?.task_title);
  const [rendered, setRendered] = useState(false);
  const [description, setDescription] = useState(task?.task_description);
  const [editorOpen, setEditorOpen] = useState(false);
  const descriptionEditorRef = useRef(null);
  const commentEditorRef = useRef(null);
  const [attachments, setAttachments] = useState(taskFiles);
  const { displayMentionName } = useMentions(
    [
      // include task creator in task team for @mention hover
      ...(task?.team || []),
      ...(task?.creator_profile &&
      !(task?.team || []).some(
        (u) => u.user_id === task.creator_profile.user_id
      )
        ? [task.creator_profile]
        : []),
    ],
    attachments || [],
    projectTeam
  );

  const mceWindowRef = useRef(null);

  const [addFilesLoading, setAddFilesLoading] = useState(false);
  const [labelDialogOpen, setDialogLabelOpen] = useState(false);
  const [isChildVisible, setChildVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [replyTarget, setReplyTarget] = useState({
    commentId: "",
  });
  const [replyValues, setReplyValues] = useState({});
  const [sendingReply, setSendingReply] = useState({}); // Track loading state per comment ID

  const [times, setTimes] = useState({
    ...task?.time_track,
  });
  const [modalRecurringEvent, setModalRecurringEvent] = useState(false);
  const [openReportTaskIssueDialog, setOpenReportTaskIssueDialog] =
    useState(false);
  const [openImprovementDialog, setOpenImprovementDialog] = useState(false);

  console.log(task, "--task");
  console.log(sections, "--sections");

  const getTaskSection = (section_id) => {};

  const [localAttachmentsFiles, setLocalAttachmentsFiles] = useState([]);
  const handleDragEnter = (e) => {
    setChildVisible(true);
  };

  const handleDragLeave = (e) => {
    setChildVisible(false);
  };

  const onDrop = (acceptedFiles) => {
    let e = {
      target: {
        files: acceptedFiles,
      },
    };
    handleFileChange(e);
    console.log("Dropped files:", acceptedFiles);
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: {
      "image/png": [],
      "image/jpeg": [],
      "image/jpg": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml": [],
      "application/msword": [],
      "application/pdf": [],
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        [],
      "text/csv": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
      "application/vnd.ms-excel": [],
      "application/vnd.ms-powerpoint": [],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [],
      "text/pdf": [],
      "video/mp4": [],
      "video/webm": [],
      "application/x-zip-compressed": [],
    },
    noClick: true,
    noKeyboard: true,
    height: "100%",
    width: "100%",
  });

  const dropzoneStyles = {
    border: isChildVisible || isDragActive ? "2px dashed #cccccc" : "",
    background: "rgba(255, 255, 255, 0.9)",
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "100%",
    height: "100%",
    transform: "translate(-50%, -50%)",
    borderRadius: "4px",
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
    transition: "border .3s ease-in-out",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    opacity: isChildVisible || isDragActive ? "0.8" : "1",
    zIndex: 10,
    fontWeight: "600",
    fontSize: "15px",
  };
  if (isDragActive && isDragAccept) {
    dropzoneStyles.border = "2px solid #4caf50"; // Accentuate with green border during drag
  } else if (isDragActive && isDragReject) {
    dropzoneStyles.border = "2px solid #f44336"; // Accentuate with red border if rejected
  }

  const targetDivRef = useRef(null);
  const targetDivFeedRef = useRef(null);

  const scrollToIssues = () => {
    targetDivRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const scrollToFeedback = () => {
    targetDivFeedRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const handleChange = () => {
    const textarea = textareaRef.current;
    textarea.style.height = "auto"; // Reset the height to auto
    textarea.style.height = textarea.scrollHeight + "px"; // Set the height to match the content

    setTaskTitle(textarea.value);
  };

  const canEditTask = (type = true) => {
    if (task?.creator) {
      return true;
    } else if (
      task?.creator_profile.user_id == dispatch_get_user_profile().user_id
    ) {
      return true;
    } else if (task.role == "admin" || task.role == "manager") {
      return true;
    }
    let found = task?.team.find(
      (user) => user.user_id == dispatch_get_user_profile().user_id
    );
    if (found && type) {
      return true;
    }

    return false;
  };
  const setNewCommentCallback = useCallback(
    (val) => {
      setNewComment(val);
    },
    [newComment]
  );

  const handleEditClick = (comment) => {
    if (editingCommentId === comment._id) {
      setEditingCommentId("");
    } else {
      setEditingCommentId(comment._id);
      onEditComment(comment);
    }
  };
  const onReplyComment = (comment) => {
    setReplyTarget((prev) =>
      prev.commentId === comment._id
        ? { commentId: "" }
        : { commentId: comment._id }
    );
    handleReplyComment(comment);
  };
  const getReplyList = (comment) => {
    if (!task?.task_comment) return [];
    // New reply comment in the last of list
    return task.task_comment
      .filter((c) => c.parent_comment_id === comment._id)
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  };

  const handleReplySubmit = async (parentComment, editorRef) => {
    const value = editorRef?.current?.getValue?.() || "";
    const trimmedValue = value.trim();
    if (!trimmedValue) return;

    setSendingReply((prev) => ({ ...prev, [parentComment._id]: true }));
    await handleSendComment([], "0", "all", trimmedValue, parentComment._id);
    setReplyValues((prev) => ({ ...prev, [parentComment._id]: "" }));
    setReplyTarget({ commentId: "" });
    setSendingReply((prev) => ({ ...prev, [parentComment._id]: false }));
  };
  const openLabelDialog = () => {
    canEditTask() && setDialogLabelOpen(true);
  };
  const closeLabelDialog = () => {
    setDialogLabelOpen(false);
  };

  // const handleFileChange = async (e) => {
  //   setAddFilesLoading(true);
  //   let final_files = [];
  //   let files = e.target.files;
  //   console.log(files, "target-files");
  //   for (let i = 0; i < files.length; i++) {
  //     console.log(files[i], "file");
  //     let findedObjectType = ALLOWED_TASK_FILES_WITH_ICONS.find((item)=>{
  //       return item.type == files[i].type;
  //     });
  //     console.log("file type object", findedObjectType);
  //   }
  //   for (let i = 0; i < files.length; i++) {
  //     ALLOWED_TASK_FILE_TYPES.map((item, index) => {
  //       if (item === String(files[i].type)) {
  //         console.log(files[i].type, "type");
  //         if (
  //           files[i].type.includes("application") ||
  //           files[i].type.includes("text")
  //         ) {
  //           final_files.push({ file: files[i], type: "file" });
  //         }
  //         if (files[i].type.includes("image")) {
  //           final_files.push({ file: files[i], type: "image" });
  //         }
  //         if (files[i].type.includes("video")) {
  //           final_files.push({ file: files[i], type: "video" });
  //         }
  //       }
  //     });
  //   }
  //   let paths = [];

  //   const newAttachments = final_files.map((selectedFile)=>{
  //     console.log(getFileIconType(selectedFile?.file?.type), selectedFile?.file?.type, "selected file");
  //     return {
  //     file: selectedFile?.file,
  //     iconPath: getFileIconType(selectedFile?.file?.name),
  //   }});

  //   setLocalAttachmentsFiles((prev) => [...prev, ...newAttachments]);
  //   // setLocalAttachmentsFiles(final_files);
  //   for (let i = 0; i < final_files.length; i++) {
  //     let res = await upload_task_files(final_files[i].file);
  //     paths.push(res.path);
  //   }
  //   paths = [...task?.image].concat(paths);

  //   updateTaskFiles(paths, "add");
  //   // setAddTaskFiles([...addTaskFiles, ...final_files]);
  // };

  async function uploadingFile(file) {
    const data = new FormData();
    data.append("directory", "images/");
    data.append("upload_file", file);
    const result = await _upload_file(data);

    console.log(result, "uploaded file");
    return result;
  }

  const handleFileChange = async (e) => {
    setAddFilesLoading(true);
    let files = e.target.files;
    let filesArray = [...files];
    const local_files = [];
    for (const selectedFile of filesArray) {
      const findedObjType = ALL_FILES_TYPES_WITH_ICONS.find((item) => {
        return item.type === selectedFile.type;
      });
      local_files.push({
        file: selectedFile,
        typeData: findedObjType,
      });
    }

    setLocalAttachmentsFiles((prev) => [...local_files, ...prev]);

    const newAttachments = [];
    for (const selectedFile of filesArray) {
      console.log(selectedFile, "File Selected");

      const findedObjType = ALL_FILES_TYPES_WITH_ICONS.find((item) => {
        return item.type === selectedFile.type;
      });

      let result = await uploadingFile(selectedFile);
      if (result.code == 200) {
        newAttachments.push({
          file: selectedFile,
          typeData: findedObjType,
          path: result.path,
        });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setAddFilesLoading(false);
        return;
      }
    }

    newAttachments.map((attachItem) => {
      return addTaskAttachment(attachItem);
    });
  };

  const addTaskAttachment = async (file) => {
    setAddFilesLoading(false);
    const req_obj = {
      task_id: task?._id,
      attachment_name: file?.file?.name,
      attachment_path: file?.path,
      attachment_type: file?.typeData?.baseTypes[0] || "other",
      attachment_size: file?.file?.size,
    };
    console.log(req_obj, "Called Attachment");

    const res = await _add_task_attachments(req_obj);
    if (res.code == 200) {
      let taskDetail = res?.task_detail;
      console.log(attachments, taskDetail.attachments, "my task detail");
      setAttachments(taskDetail?.attachments);
      setLocalAttachmentsFiles([]);
    } else {
      enqueueSnackbar(res.message, { variant: "error" });
    }
    setAddFilesLoading(false);
  };

  const handleCopyTaskLink = async (task) => {
    const { section_id, _id } = task;
    let project_id = task?.project.id;
    console.log(task, "to-copy");
    let newLink = "";
    newLink = `${window.location.origin}/workspaces/copied-task-link/${project_id}/${section_id}/${_id}`;
    console.log(newLink);
    let has_error = "";
    try {
      await window.navigator.clipboard.writeText(newLink);
    } catch (error) {
      if (error) {
        if (error.message) {
          has_error = error.message;
        }
      }
      enqueueSnackbar("Something went wrong!", { variant: "error" });
    }
    if (has_error === "") {
      enqueueSnackbar("Task link copied to clipboard", {
        variant: "success",
      });
      return;
    }
    enqueueSnackbar("Could not copy task link", { variant: "error" });
  };
  const updateTask = async (action, newDescription = null) => {
    try {
      const req_obj = {
        task_id: task?._id,
        image: attachments.map((file) => {
          return file.db_path;
        }),
        task_title: taskTitle,
        activity_change_type: action,
        task_description:
          newDescription !== null ? newDescription : description,
        time_track: {
          estimated_time:
            times.estimated_time && !times.estimated_time.includes(":")
              ? times.estimated_time.padStart(2, "0") + ":00"
              : times.estimated_time &&
                times.estimated_time.includes(":") &&
                times.estimated_time.split(":")[1].length < 2
              ? times.estimated_time.split(":")[0] +
                ":" +
                times.estimated_time.split(":")[1].padStart(2, "0")
              : times.estimated_time,
          actual_time:
            times.actual_time && !times.actual_time.includes(":")
              ? times.actual_time.padStart(2, "0") + ":00"
              : times.actual_time &&
                times.actual_time.includes(":") &&
                times.actual_time.split(":")[1].length < 2
              ? times.actual_time.split(":")[0] +
                ":" +
                times.actual_time.split(":")[1].padStart(2, "0")
              : times.actual_time,
          final_time:
            times.final_time && !times.final_time.includes(":")
              ? times.final_time.padStart(2, "0") + ":00"
              : times.final_time &&
                times.final_time.includes(":") &&
                times.final_time.split(":")[1].length < 2
              ? times.final_time.split(":")[0] +
                ":" +
                times.final_time.split(":")[1].padStart(2, "0")
              : times.final_time,
        },
      };
      const result = await _edit_task(req_obj);
      if (result.code !== 200) {
        enqueueSnackbar(result.message, { variant: "error" });
      } else {
        if (task?.project_data) {
          setTask((prev) => {
            return { ...result.task_data, project_data: prev.project_data };
          });
        } else {
          setTask(result.task_data);
        }

        setTasks(task.section_id, task._id, result.task_data);
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
    }
  };
  const excludedStatusOptions = () => {
    const currentUserRole = task?.role;
    const creator_profile = task?.creator_profile;

    if (!currentUserRole) {
      return [5];
    }
    if (creator_profile.user_id === dispatch_get_user_profile().user_id) {
      return [5];
    }
    if (currentUserRole === "admin") {
      return [5];
    }
    if (currentUserRole === "manager") {
      return [5];
    }
    if (currentUserRole === "client" || currentUserRole === "client_team") {
      return [5];
    }
    if (currentUserRole === "team") {
      return [4, 5]; /* exclude verified status for team */
    }
  };
  const onPriorityChange = (_data) => {
    const data = {
      task: task,
      section: { _id: task?.section_id },
      priority: _data.value,
    };
    onChangePriority(data, task?.workspace.id);
  };
  const onTaskStatusChange = (_data) => {
    const data = {
      task: task,
      section: { _id: task?.section_id },
      status: _data.value,
      is_checkbox: false,
    };
    onChangeStatus(data, task?.workspace.id);
  };
  const onTeamChange = (target_user, task_team, is_selected, action) => {
    const data = {
      task: task,
      section: { _id: task?.section_id },
      taskTeam: task_team,
      targetUser: target_user,
      isSelected: is_selected,
      action: action,
    };
    onChangeMembers(data, task?.workspace.id);
  };
  ////////////////////////////////////////////////////////////////////////
  const markCommentAsRead = async (type = "single", commentId = null) => {
    const payload = {
      type,
      ...(type === "single" && {
        comment_id: commentId,
      }),
      ...(type === "multiple" && {
        comment_ids: commentId,
      }),
    };

    const result = await _mark_task_comment_as_read(payload, task?._id);

    if (result.code === 200) {
      const updatedTask = {
        ...task,
        task_comment_unread_count:
          type === "all"
            ? 0
            : type === "multiple"
            ? Math.max(
                0,
                (task.task_comment_unread_count || 0) - commentId.length
              )
            : Math.max(0, (task.task_comment_unread_count || 1) - 1),
        task_comment: task.task_comment.map((comment) => {
          if (
            type === "all" ||
            (type === "single" && comment._id === commentId) ||
            (type === "multiple" && commentId.includes(comment._id))
          ) {
            return {
              ...comment,
              unread_users: comment.unread_users?.filter(
                (u) => u.user_id !== userId
              ),
            };
          }
          return comment;
        }),
      };

      setTask(updatedTask);
      setTasks(task.section_id, task._id, updatedTask);
      if (type === "all") {
        enqueueSnackbar(result.message, { variant: "success" });
      }
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  ////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    setNewComment("");
  }, [editingCommentId]);
  useEffect(() => {
    if (taskTitle) {
      setRendered(true);
      const elm = document.getElementsByClassName("task-title")[0];
      if (elm) {
        elm.style.height = "auto";
        elm.style.height = elm.scrollHeight + "px";
      }
    }
    return () => {
      setRendered(false);
    };
  }, [rendered, taskTitle, task]);

  const getTaskDetail = async () => {
    try {
      const result = await _task_detail(task?._id);
      if (result.code == 200) {
        setTimes(result.task_detail.time_track);
        setDescription(result.task_detail.task_description);
        setAttachments(result.task_detail.attachments || []);
        if (task?.sectionData) {
          setTask({ ...task, ...result.task_detail });
        } else {
          setTask({
            ...result.task_detail,
            sectionData: {
              _id: result.task_detail.section_id,
              section_title: result.task_detail.section_title,
              task: [{ ...result.task_detail }],
            },
          });
        }
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        onClose();
      }
    } catch (error) {
      console.log(error, "catched while fetchig task details");
      onClose();
    } finally {
      setTaskDetailLoading(false);
    }
  };
  useEffect(() => {
    if (open) {
      getTaskDetail();
      // window.history.replaceState(null, "");
      setDescription(task?.task_description);
      setTimes(task?.time_track);
    } else {
      // Reset editor open state when dialog closes
      setEditorOpen(false);
    }
    return () => {
      setTaskDetailLoading(true);
    };
  }, [open]);

  // --------> Replace "Copy task Link" with "Current link" in browser <--------
  useEffect(() => {
    if (!open || !task) return;
    const { section_id, _id } = task;
    const project_id = task?.project?.id;
    if (project_id && section_id && _id) {
      const currentUrl = window.location.pathname + window.location.search;
      if (!currentUrl.includes("/workspaces/copied-task-link/")) {
        sessionStorage.setItem("prevUrl", currentUrl);
      }
      const taskUrl = `/workspaces/copied-task-link/${project_id}/${section_id}/${_id}`;
      window.history.replaceState(
        { taskDetailOpen: true, task_id: _id },
        "",
        taskUrl
      );
    }
  }, [task?.project?.id, task?.section_id, task?._id, open]);
  // --------> Restore the original URL when dialog is closed or unmounted <--------
  useEffect(() => {
    const restoreUrl = () => {
      const prevUrl = sessionStorage.getItem("prevUrl");
      if (prevUrl) {
        window.history.replaceState({}, "", prevUrl);
        sessionStorage.removeItem("prevUrl");
      }
    };
    if (!open) {
      restoreUrl();
    }
    return () => {
      restoreUrl();
    };
  }, [open]);
  // =======================================================================
  useEffect(() => {
    setTaskTitle(task?.task_title);
    // setDescription(task?.task_description);
    // Don't reset attachments from task to preserve local updates (add/rename)
  }, [task]);
  useEffect(() => {
    if (open) {
      window.addEventListener("dragenter", handleDragEnter);
      window.addEventListener("dragover", handleDragEnter);
      window.addEventListener("dragleave", handleDragLeave);
      window.addEventListener("drop", handleDragLeave);
    }
    return () => {
      removeEventListener("dragover", () => {
        console.log("event removed");
      });
      removeEventListener("dragleave", () => {
        console.log("event removed");
      });
      removeEventListener("drop", () => {
        console.log("event removed");
      });
    };
  }, [open]);

  useEffect(() => {
    if (nodeListRef.current) {
      const handleMutation = (mutations) => {
        mutations.forEach((mutation) => {
          const targetElement = mutation.target;
          if (
            (targetElement instanceof HTMLTextAreaElement &&
              !targetElement.hasAttribute("data-gramm")) ||
            ((targetElement.tagName.toLowerCase() === "grammarly-extension" ||
              targetElement.tagName.toLowerCase() === "grammarly-popups" ||
              targetElement.tagName.toLowerCase() === "grammarly-mirror" ||
              targetElement.tagName.toLowerCase() ===
                "grammarly-desktop-integration") &&
              !targetElement.hasAttribute("data-removed"))
          ) {
            if (
              targetElement.tagName.toLowerCase() === "grammarly-extension" ||
              targetElement.tagName.toLowerCase() === "grammarly-popups" ||
              targetElement.tagName.toLowerCase() === "grammarly-mirror" ||
              targetElement.tagName.toLowerCase() ===
                "grammarly-desktop-integration"
            ) {
              targetElement.remove();
            } else if (targetElement instanceof HTMLTextAreaElement) {
              targetElement.setAttribute("data-gramm", "false");
              targetElement.setAttribute("data-gramm_editor", "false");
              targetElement.setAttribute("data-enable-grammarly", "false");
            }
          }
        });
      };

      const observer = new MutationObserver(handleMutation);
      observer.observe(nodeListRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
      });
      return () => {
        observer.disconnect();
      };
    }
  }, [nodeListRef.current]);

  // ---------------------- count for issues / FeedBack ----------------------
  const allResolved =
    task?.task_checklist_stats?.issues_stats?.completed_count ===
      task?.task_checklist_stats?.issues_stats?.total_count &&
    task?.task_checklist_stats?.issues_stats?.total_count !== 0;
  const all_feedback_resolved =
    task?.task_checklist_stats?.improvements_stats?.completed_count ===
      task?.task_checklist_stats?.improvements_stats?.total_count &&
    task?.task_checklist_stats?.improvements_stats?.total_count !== 0;

  return (
    <>
      <Dialog
        id="modaaaal"
        disableEnforceFocus={true}
        open={open}
        onClose={() => {
          addFilesLoading &&
            enqueueSnackbar("Uploading Files!", { variant: "warning" });
          !addFilesLoading && onClose();
        }}
        maxWidth="md"
        fullWidth
        scroll="body"
        // scroll="paper" // for dialog scroll
        PaperProps={{
          className: is_mobile_view ? "dialog-paper-mobile" : "dialog-paper",
        }}
        classes={{
          scrollPaper: classes.topScrollPaper,
          paperScrollBody: classes.topPaperScrollBody,
        }}
        fullScreen={is_mobile_view}
        sx={{ margin: is_mobile_view && "50px 10px 0px" }}
      >
        {task && (
          <DialogContent
            // onDragEnter={handleDragEnter}
            // onDragLeave={handleDragLeave}
            sx={{ p: 0, py: 1 }}
            onClick={() => {
              // setAddingChecklistItem("");
              // setNewChecklistItem("");
              // setEditChecklistItem("");
            }}
          >
            {taskDetailLoading && (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "90vh" }}
              >
                <CircularProgress sx={{ flexShrink: 0 }} />
              </div>
            )}
            {!taskDetailLoading && (
              <div
                ref={nodeListRef}
                style={{ position: "relative" }}
                id="task-detail"
                // onDragEnter={handleDragEnter}
                // onDragLeave={handleDragLeave}
              >
                {(isChildVisible || isDragActive) && (
                  <div {...getRootProps()} style={dropzoneStyles}>
                    <input
                      {...getInputProps()}
                      // style={{ height: "100%", width: "100%" }}
                    />
                    {isDragReject && <p>File type not accepted</p>}
                    {/* Render content only when drag is active */}
                    {(isDragActive || (!isDragReject && isChildVisible)) && (
                      <p>Drop files here</p>
                    )}
                  </div>
                )}
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        className="d-flex justify-content-between align-items-center border-bottom ps-3 pe-3 pb-1 fs-10"
                      >
                        {is_mobile_view ? (
                          <div className="d-flex align-items-center task-top-header">
                            <Typography className="fs-12 fw-5">
                              {string_with_limited_length(
                                task.workspace.name,
                                9
                              )}
                            </Typography>
                            <Iconify icon="grommet-icons:next" sx={{ m: 1 }} />
                            <Typography className="fs-12 fw-5">
                              {string_with_limited_length(task.project.name, 9)}
                            </Typography>
                            {task.section_title && task.section_title && (
                              <>
                                <Iconify
                                  icon="grommet-icons:next"
                                  sx={{ m: 1 }}
                                />
                                <Typography className="fs-12 fw-5">
                                  {string_with_limited_length(
                                    task.section_title,
                                    9
                                  )}
                                </Typography>
                              </>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex align-items-center task-top-header me-4">
                            <Typography className="fs-12 fw-5">
                              {string_with_limited_length(
                                task.workspace.name,
                                50
                              )}
                            </Typography>
                            <Iconify icon="grommet-icons:next" sx={{ m: 1 }} />
                            <Typography className="fs-12 fw-5">
                              {string_with_limited_length(
                                task.project.name,
                                50
                              )}
                            </Typography>
                            {task.section_title && task.section_title && (
                              <>
                                <Iconify
                                  icon="grommet-icons:next"
                                  sx={{ m: 1 }}
                                />
                                <Typography className="fs-12 fw-5">
                                  {string_with_limited_length(
                                    task.section_title,
                                    40
                                  )}
                                </Typography>
                              </>
                            )}
                          </div>
                        )}

                        <div className="d-flex justify-content-center align-items-center">
                          {handleNavigate && (
                            <div className="me-2">
                              <Tooltip title="Open in project" arrow>
                                <span>
                                  <Iconify
                                    icon="majesticons:open"
                                    sx={{
                                      height: "20px",
                                      width: "20px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleNavigate(task)}
                                  />
                                </span>
                              </Tooltip>
                            </div>
                          )}
                          <div className="d-flex align-items-center gap-2">
                            <Iconify
                              icon="ion-close"
                              sx={{
                                height: "24px",
                                width: "24px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                addFilesLoading &&
                                  enqueueSnackbar("Uploading Files!", {
                                    variant: "warning",
                                  });
                                !addFilesLoading && onClose();
                              }}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div
                          className="textarea-wrapper"
                          style={{ marginLeft: "25px" }}
                        >
                          {isEditing === true ? (
                            <textarea
                              className="task-title"
                              autoFocus
                              style={{
                                resize: "none",
                                overflowY: "hidden",
                                fontSize: is_mobile_view && "14px",
                                padding: is_mobile_view
                                  ? "6px 0px"
                                  : "6px 10px",
                              }}
                              spellCheck={false}
                              ref={textareaRef}
                              onFocus={(e) => {
                                // Move cursor to last : Shamroz
                                const value = e.target.value;
                                e.target.setSelectionRange(
                                  value.length,
                                  value.length
                                );
                              }}
                              value={taskTitle}
                              onChange={handleChange}
                              disabled={!canEditTask(false)}
                              // onClick={(e) => e.stopPropagation()}
                              onBlur={() => {
                                if (taskTitle.trim() === task?.task_title) {
                                  setIsEditing(false);
                                  return;
                                }
                                if (!taskTitle.trim()) {
                                  // document
                                  //   .getElementsByClassName("task-title")[0]
                                  //   .focus();
                                  // setTaskTitle(task?.task_title);
                                } else {
                                  updateTask("title_change");
                                }
                                setIsEditing(false);
                              }}
                            />
                          ) : (
                            <div
                              className="task-title"
                              style={{
                                fontSize: is_mobile_view && "14px",
                                padding: is_mobile_view
                                  ? "6px 0px"
                                  : "6px 10px",
                              }}
                              dangerouslySetInnerHTML={replacedText(taskTitle)}
                              onClick={() => {
                                setIsEditing(true);
                              }}
                            ></div>
                          )}
                          {/* <div contentEditable={true}>ascasiocuas</div> */}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    md={9}
                    xs={12}
                    className="window-main-col"
                    sx={{
                      padding: is_mobile_view
                        ? "0 14px 8px 16px"
                        : "0 8px 8px 16px",
                    }}
                  >
                    <Grid item xs={12}>
                      <div className="d-flex gap-1">
                        <div style={{ width: is_mobile_view && "100%" }}>
                          <div
                            style={{
                              fontSize: "12px",
                              marginLeft: is_mobile_view ? "14px" : "50px",
                              // paddingBottom: "2px",
                              fontWeight: "600",
                            }}
                          >
                            Created By
                          </div>
                          <div
                            style={{
                              marginLeft: is_mobile_view ? "14px" : "50px",
                            }}
                            className="d-flex align-items-center"
                          >
                            <div
                              className="sidebar-button align-items-center"
                              style={{
                                display: "flex",
                                fontWeight: "500",
                                minHeight: "36px",
                                justifyContent: is_mobile_view && "flex-start",
                                width: is_mobile_view && "100%",
                              }}
                            >
                              <UserAvatar
                                image={task?.creator_profile.image}
                                name={task?.creator_profile.first_name}
                                sx={{
                                  width: "24px",
                                  height: "24px",
                                  marginRight: "8px",
                                }}
                              />
                              {is_mobile_view
                                ? truncateText(
                                    `${task?.creator_profile?.first_name} ${task?.creator_profile?.last_name}`,
                                    10
                                  )
                                : `${task?.creator_profile?.first_name} ${task?.creator_profile?.last_name}`}
                            </div>
                          </div>
                        </div>
                        <div style={{ width: is_mobile_view && "100%" }}>
                          <div className="d-flex align-items-center gap-1">
                            <div
                              style={{
                                fontSize: "12px",
                                marginLeft: is_mobile_view ? "14px" : "50px",
                                // paddingBottom: "2px",
                                fontWeight: "600",
                              }}
                            >
                              Created At
                            </div>
                            {/* only show to the task creator ---------- */}
                            {task.is_recurring === true &&
                              task?.creator_profile?.user_id ===
                                dispatch_get_user_profile().user_id && (
                                <Tooltip title="A System Generated Task is a recurring task that is automatically created by the system based on the schedule you've set.">
                                  <span className="system-genrated-chip">
                                    System Generated
                                  </span>
                                </Tooltip>
                              )}
                          </div>

                          <div
                            style={{
                              marginLeft: is_mobile_view ? "14px" : "50px",
                            }}
                            className="d-flex align-items-center"
                          >
                            <div
                              className="sidebar-button"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontWeight: "500",
                                minHeight: "36px",
                                fontSize: is_mobile_view && "12px",
                              }}
                            >
                              {is_mobile_view
                                ? moment(task?.createdAt).format(
                                    "MMM D, YYYY, h:mm A"
                                  )
                                : moment(task?.createdAt).format("LLL")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    {/* {task?.tag_colors.length > 0 && ( */}
                    <Grid
                      item
                      xs={12}
                      sx={{ paddingLeft: is_mobile_view ? "14px" : "50px" }}
                    >
                      <Typography
                        className="pt-2 mb-1"
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        Labels
                      </Typography>

                      <Stack
                        direction="row"
                        flexWrap={is_mobile_view ? "nowrap" : "wrap"}
                        gap={1}
                        sx={{
                          fontSize: is_mobile_view && "12px",
                          overflowX: is_mobile_view ? "auto" : "visible",
                          whiteSpace: is_mobile_view ? "nowrap" : "normal",
                          pb: is_mobile_view ? 1 : 0,
                          "&::-webkit-scrollbar": is_mobile_view
                            ? {
                                height: "6px",
                              }
                            : {},
                          "&::-webkit-scrollbar-thumb": is_mobile_view
                            ? {
                                backgroundColor: "#ccc",
                                borderRadius: "10px",
                              }
                            : {},
                        }}
                      >
                        {task?.tag_colors?.map((tag, i) => {
                          return (
                            <div
                              className="d-flex align-items-center"
                              key={i}
                              style={{
                                padding: "4px 8px",
                                minWidth: "max-content",
                                maxHeight: "30px",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "3px",
                                borderLeft: `6px solid ${tag.color_code}`,
                              }}
                            >
                              {tag.name}
                            </div>
                          );
                        })}
                        <div
                          className="sidebar-button  d-flex align-items-center justify-content-center"
                          style={{ maxHeight: "30px" }}
                          onClick={() => {
                            canEditTask() && openLabelDialog();
                          }}
                        >
                          <Iconify
                            icon="tabler:plus"
                            sx={{ width: "20px", height: "20px" }}
                          />
                        </div>
                      </Stack>
                    </Grid>

                    <Grid
                      container
                      spacing={1.5}
                      sx={{
                        paddingLeft: is_mobile_view ? "14px" : "50px",
                        mt: 0.5,
                      }}
                    >
                      {/* Row 1 -------------------- */}
                      <Grid item xs={6} md={4}>
                        {/* Component 1 */}
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Target Date
                          </div>
                          <div
                            // style={{ marginLeft: "10px" }}
                            className="d-flex align-items-center"
                          >
                            <div
                              className="sidebar-button"
                              style={{
                                display: "flex",
                                fontWeight: "500",
                                minHeight: "36px",
                                width: "100%",
                              }}
                            >
                              <TaskDatePick
                                hasPortal
                                value={task?.end_date}
                                onChange={(newDate) =>
                                  onChangeDate(
                                    {
                                      task: task,
                                      section: { _id: task?.section_id },
                                      endDate: newDate,
                                    },
                                    task?.workspace.id
                                  )
                                }
                                task={task}
                                disabled={!canEditTask()}
                              />
                            </div>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        {/* Component 2 */}
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Priority
                          </div>
                          <div
                            style={{
                              fontWeight: "500",
                              minHeight: "36px",
                            }}
                          >
                            <PriorityButton
                              value={task?.priority}
                              allowOpen={canEditTask()}
                              onChange={onPriorityChange}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        {/* Component 3 */}
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Status
                          </div>
                          <div
                            style={{
                              fontWeight: "500",
                              minHeight: "36px",
                            }}
                          >
                            <StatusButton
                              value={task?.task_status}
                              allowOpen={canEditTask()}
                              onChange={onTaskStatusChange}
                              extraStatus={task?.extra_status}
                              excludedOptions={excludedStatusOptions()}
                            />
                          </div>
                        </div>
                      </Grid>

                      {/* Row 2 -------------------- */}
                      <Grid item xs={6} md={4}>
                        {/* Component 4 */}
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Members
                          </div>
                          <div>
                            <MembersButton
                              canEditTask={canEditTask()}
                              taskTeam={task?.team}
                              projectTeam={projectTeam}
                              loadingMember={loadingMember}
                              onChange={(
                                target_user,
                                taskTeam,
                                is_selected,
                                action
                              ) =>
                                onTeamChange(
                                  target_user,
                                  taskTeam,
                                  is_selected,
                                  action
                                )
                              }
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        {/* Component 5 */}
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Planned Time
                          </div>
                          <div
                            style={{
                              fontWeight: "500",
                              minHeight: "36px",
                            }}
                          >
                            <PlannedTimeInput
                              userId={dispatch_get_user_profile().user_id}
                              task={task}
                              getTaskDetail={getTaskDetail}
                              canEditTask={canEditTask()}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        {/* Component 6 */}
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Timer
                          </div>
                          <div
                            style={{
                              fontWeight: "500",
                              minHeight: "36px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Timer
                              canEditTask={canEditTask()}
                              task={task}
                              getTaskDetail={getTaskDetail}
                              getFilteredSections={getFilteredSections}
                            />
                          </div>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={1.5}
                      sx={{
                        paddingLeft: is_mobile_view ? "14px" : "50px",
                        mt: 1,
                      }}
                    >
                      {/* Row 1 */}
                      {task?.role !== "client" &&
                        task?.role !== "client_team" && (
                          <Grid item xs={6} md={4}>
                            <MuiAutoCompleteTimes
                              label="Estimated Time"
                              nameprop="estimated_time"
                              value={times.estimated_time}
                              onChange={(value) =>
                                setTimes((prev) => ({
                                  ...prev,
                                  estimated_time: value,
                                }))
                              }
                              updateTask={() => {
                                updateTask("estimated_time_change");
                              }}
                              canEditTask={canEditTask}
                              placeholder="hh:mm"
                              error={
                                !times?.estimated_time &&
                                (task?.task_status == 0 ||
                                  task?.task_status == 2)
                              }
                            />
                          </Grid>
                        )}
                      {task?.role !== "client" &&
                        task?.role !== "client_team" && (
                          <Grid item xs={6} md={4}>
                            <MuiAutoCompleteTimes
                              label="Complete Time"
                              nameprop="actual_time"
                              value={times.actual_time}
                              onChange={(value) =>
                                setTimes((prev) => ({
                                  ...prev,
                                  actual_time: value,
                                }))
                              }
                              updateTask={() => {
                                updateTask("actual_time_change");
                              }}
                              canEditTask={canEditTask}
                              placeholder="hh:mm"
                              error={
                                !times?.actual_time && task?.task_status == 3
                              }
                            />
                          </Grid>
                        )}
                      {task?.role !== "team" && (
                        <Grid item xs={6} md={4}>
                          <MuiAutoCompleteTimes
                            label={
                              task?.role == "client" ||
                              task?.role == "client_team"
                                ? "Completed Time"
                                : "Billable Time"
                            }
                            nameprop="final_time"
                            value={times.final_time}
                            onChange={(value) =>
                              setTimes((prev) => ({
                                ...prev,
                                final_time: value,
                              }))
                            }
                            updateTask={() => {
                              updateTask("final_time_change");
                            }}
                            canEditTask={canEditTask}
                            //   disabled={
                            //   !canEditTask() ||
                            //   task?.role == "client" ||
                            //   task?.role == "client_team"
                            // }
                            placeholder="hh:mm"
                            // error={!times?.final_time}
                          />
                        </Grid>
                      )}
                    </Grid>

                    {/* description ------------------------------ */}
                    <Grid
                      container
                      spacing={1}
                      sx={{ paddingLeft: is_mobile_view && "10px" }}
                    >
                      <Grid item xs={1}>
                        <div className="d-flex justify-content-end pt-3">
                          <Iconify
                            icon="fluent:text-description-32-filled"
                            sx={{ height: "24px", width: "24px" }}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={11}>
                        <div className="pt-3">
                          <h5 style={{ fontSize: "1.15rem" }}>Description</h5>
                          {!editorOpen && (
                            <div
                              className="no-description-div"
                              onClick={(e) => {
                                if (e.target.closest("a")) {
                                  // if click on Link dont set editing true - shamroz
                                  console.log(e.target, "link_opened");
                                  return;
                                }
                                if (canEditTask(false)) {
                                  e.stopPropagation();
                                  setEditorOpen(true);
                                }
                              }}
                            >
                              {!description ? (
                                "Add a more detailed description..."
                              ) : (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: displayMentionName(description),
                                  }}
                                  style={{
                                    wordWrap: "break-word",
                                    wordBreak: "break-word",
                                  }}
                                />
                              )}
                            </div>
                          )}
                          {editorOpen && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <MentionMemoEditor
                                ref={descriptionEditorRef}
                                value={description}
                                editorHeight={300}
                                team={[
                                  // include task creator in task team for @mention
                                  ...(task?.team || []),
                                  ...(task?.creator_profile &&
                                  !(task?.team || []).some(
                                    (u) =>
                                      u.user_id === task.creator_profile.user_id
                                  )
                                    ? [task.creator_profile]
                                    : []),
                                ]}
                                canMention={false}
                                attachments={attachments || []}
                              />
                              <div className="d-flex mt-2">
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => {
                                    const val =
                                      descriptionEditorRef.current.getValue();
                                    setDescription(val);
                                    updateTask("description_change", val);
                                    setEditorOpen(false);
                                  }}
                                >
                                  Save
                                </Button>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  sx={{ ml: 1 }}
                                  onClick={() => {
                                    setEditorOpen(false);
                                  }}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                    {/* Attachments ------------------------------ */}
                    {attachments.length > 0 && (
                      <Grid
                        container
                        spacing={1}
                        sx={{ paddingLeft: is_mobile_view && "10px" }}
                      >
                        <Grid item xs={1}>
                          <div className="d-flex justify-content-end pt-3">
                            <Iconify
                              icon="grommet-icons:attachment"
                              sx={{ height: "24px", width: "24px" }}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={11}>
                          <div className="pt-3 ps-1 w-100">
                            <div className="d-flex justify-content-between">
                              <h5 style={{ fontSize: "1.15rem" }}>
                                Attachments (
                                {localAttachmentsFiles.length +
                                  attachments.length}
                                )
                              </h5>
                              {canEditTask() && (
                                <div>
                                  <label htmlFor="icon-button-file">
                                    <input
                                      style={{ display: "none" }}
                                      accept={FILE_ACCEPT_TYPE_STRING}
                                      id="icon-button-file"
                                      type="file"
                                      value=""
                                      onChange={handleFileChange}
                                      multiple
                                      disabled={addFilesLoading}
                                    />
                                    <div
                                      className="sidebar-button d-flex justify-content-center"
                                      style={{ minWidth: "55px" }}
                                    >
                                      {!addFilesLoading && <>Add</>}
                                      {addFilesLoading && (
                                        <div>
                                          <CircularProgress size={"15px"} />
                                        </div>
                                      )}
                                    </div>
                                  </label>
                                </div>
                              )}
                            </div>
                            <div className="row no-gutter mt-2">
                              <TaskAttachments
                                attachments={attachments}
                                setAttachments={setAttachments}
                                localAttachmentsFiles={localAttachmentsFiles}
                                setLocalAttachmentsFiles={
                                  setLocalAttachmentsFiles
                                }
                                taskId={task._id}
                                canEditTask={canEditTask()}
                              />
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    )}
                    {/* Checklist --------------------------------*/}
                    {task?.check_list?.some((c) => c.checklist_type === 0) && (
                      <div className="checklist-div">
                        <Divider className="divider-li" component="li" />
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            className="accordion-Summary ps-0"
                            expandIcon={
                              <ExpandMoreIcon className="expand-more-Icon" />
                            }
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            <Grid container spacing={1}>
                              <Grid item xs={1}>
                                <div className="d-flex justify-content-end pt-3">
                                  <Iconify
                                    icon="sidekickicons:checklist"
                                    sx={{ height: "24px", width: "24px" }}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={11}>
                                <div className="pt-3">
                                  <h5 style={{ fontSize: "1.15rem" }}>
                                    Checklists (
                                    {
                                      task?.check_list?.filter(
                                        (c) => c.checklist_type === 0
                                      ).length
                                    }
                                    )
                                  </h5>
                                </div>
                              </Grid>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            {task?.check_list
                              ?.filter(
                                (checklist) => checklist.checklist_type === 0
                              )
                              .map((checklist, i) => (
                                <CheckListItem
                                  key={i}
                                  checklist={checklist}
                                  setEditorOpen={setEditorOpen}
                                  canEditTask={canEditTask()}
                                  task={task}
                                  setTask={setTask}
                                  setTasks={setTasks}
                                  getTaskDetail={getTaskDetail}
                                />
                              ))}
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}

                    {/* Issues Checklist --------------------------------*/}
                    {task?.check_list?.some((c) => c.checklist_type === 1) && (
                      <div ref={targetDivRef} className="checklist-div">
                        <Divider className="divider-li" component="li" />
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            className="accordion-Summary ps-0"
                            expandIcon={
                              <ExpandMoreIcon className="expand-more-Icon" />
                            }
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            <Grid container spacing={1}>
                              <Grid item xs={1}>
                                <div className="d-flex justify-content-end pt-3">
                                  <Iconify
                                    icon="ph:warning-duotone"
                                    sx={{ height: "24px", width: "24px" }}
                                    color="#e48e03"
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={11}>
                                <div className="pt-3">
                                  <h5 style={{ fontSize: "1.15rem" }}>
                                    Reported Issues
                                  </h5>
                                </div>
                              </Grid>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            {task?.check_list
                              ?.filter(
                                (checklist) => checklist.checklist_type === 1
                              )
                              .map((checklist, i) => (
                                <CheckListItem
                                  key={i}
                                  checklist={checklist}
                                  setEditorOpen={setEditorOpen}
                                  canEditTask={canEditTask()}
                                  task={task}
                                  setTask={setTask}
                                  setTasks={setTasks}
                                  getTaskDetail={getTaskDetail}
                                />
                              ))}
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}

                    {/* FeedBack Checklist --------------------------------*/}
                    {task?.check_list?.some((c) => c.checklist_type === 2) && (
                      <div ref={targetDivFeedRef} className="checklist-div">
                        <Divider className="divider-li" component="li" />
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            className="accordion-Summary ps-0"
                            expandIcon={
                              <ExpandMoreIcon className="expand-more-Icon" />
                            }
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            <Grid container spacing={1}>
                              <Grid item xs={1}>
                                <div className="d-flex justify-content-end pt-3">
                                  <Iconify
                                    icon="codicon:feedback"
                                    sx={{ height: "24px", width: "24px" }}
                                    color="#1890FF"
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={11}>
                                <div className="pt-3">
                                  <h5 style={{ fontSize: "1.15rem" }}>
                                    Feedbacks
                                  </h5>
                                </div>
                              </Grid>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            {task?.check_list
                              ?.filter(
                                (checklist) => checklist.checklist_type === 2
                              )
                              .map((checklist, i) => (
                                <CheckListItem
                                  key={i}
                                  checklist={checklist}
                                  setEditorOpen={setEditorOpen}
                                  canEditTask={canEditTask()}
                                  task={task}
                                  setTask={setTask}
                                  setTasks={setTasks}
                                  getTaskDetail={getTaskDetail}
                                />
                              ))}
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}

                    {/* Time_Block --------------------------------*/}
                    {canEditTask() && (
                      <TimeBlock getTaskDetail={getTaskDetail} task={task} />
                    )}
                    {/* ------------------------------------------ */}
                    <Grid
                      container
                      spacing={1}
                      sx={{ paddingLeft: is_mobile_view && "10px" }}
                      // Add ref for scrolling
                      ref={commentsRef}
                      data-comments-section
                    >
                      <Grid item xs={1}>
                        <div className="d-flex align-items-end justify-content-end h-100">
                          <Iconify
                            icon="majesticons:comments-line"
                            sx={{ height: "24px", width: "24px" }}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={11}>
                        <div className="pt-3 d-flex align-items-center justify-content-between">
                          <h5
                            style={{
                              fontSize: "1.15rem",
                              marginBottom: "3px",
                            }}
                          >
                            Comments
                          </h5>

                          {task?.task_comment?.some((comment) =>
                            comment.unread_users?.some(
                              (u) => u.user_id === userId
                            )
                          ) && (
                            <Button
                              size="small"
                              variant="text"
                              color="primary"
                              startIcon={
                                <Iconify
                                  icon="mingcute:check-fill"
                                  height={13}
                                  width={13}
                                />
                              }
                              sx={{
                                fontSize: "12px",
                                fontWeight: 400,
                                textTransform: "none",
                                padding: "0 6px",
                                minWidth: "auto",
                                borderRadius: "4px",
                                // "&:hover": { textDecoration: "underline" },
                              }}
                              onClick={() => markCommentAsRead("all")}
                            >
                              Mark all as read
                            </Button>
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div
                          className={
                            is_mobile_view ? "" : "p-4 pe-0 pb-0 d-flex"
                          }
                        >
                          {!is_mobile_view && (
                            <UserAvatar
                              image={dispatch_get_user_profile().image}
                              alt={dispatch_get_user_profile().first_name}
                              name={dispatch_get_user_profile().first_name}
                            />
                          )}

                          <div className="px-2 w-100">
                            {editingCommentId !== "add" && (
                              <div
                                className="comment-data add-comment-field"
                                onClick={() => setEditingCommentId("add")}
                              >
                                Write a comment...
                              </div>
                            )}
                            {editingCommentId === "add" && (
                              <>
                                <MentionMemoEditor
                                  ref={commentEditorRef}
                                  value={newComment}
                                  team={[
                                    // include task creator in task team for @mention hover
                                    ...(task?.team || []),
                                    ...(task?.creator_profile &&
                                    !(task?.team || []).some(
                                      (u) =>
                                        u.user_id ===
                                        task.creator_profile.user_id
                                    )
                                      ? [task.creator_profile]
                                      : []),
                                  ]}
                                  mentionableTeam={
                                    task?.role === "client" ||
                                    task?.role === "client_team"
                                      ? [
                                          // include task creator in task team for @mention hover
                                          ...(task?.team?.filter((user) =>
                                            projectTeam?.some(
                                              (pu) =>
                                                pu.user_id === user.user_id
                                            )
                                          ) || []),
                                          ...(task?.creator_profile &&
                                          !(
                                            task?.team?.filter((user) =>
                                              projectTeam?.some(
                                                (pu) =>
                                                  pu.user_id === user.user_id
                                              )
                                            ) || []
                                          ).some(
                                            (u) =>
                                              u.user_id ===
                                              task.creator_profile.user_id
                                          )
                                            ? [task.creator_profile]
                                            : []),
                                        ]
                                      : [
                                          ...(task?.team || []),
                                          ...(task?.creator_profile &&
                                          !(task?.team || []).some(
                                            (u) =>
                                              u.user_id ===
                                              task.creator_profile.user_id
                                          )
                                            ? [task.creator_profile]
                                            : []),
                                        ]
                                  }
                                  editorRef={editorRef}
                                  editorHeight={300}
                                  placeHolder="Write a comment..."
                                  canMention={true}
                                  attachments={attachments || []}
                                />
                                {/* Notify selected user ------------------------- shamroz */}
                                <NotifySelectedUser
                                  taskTeam={task?.team}
                                  projectTeam={projectTeam}
                                  // coment save button props ----
                                  addCommentLoading={addCommentLoading}
                                  handleSendComment={handleSendComment}
                                  setEditingCommentId={setEditingCommentId}
                                  commentEditorRef={commentEditorRef}
                                />
                                {/* ------------------------------------------------------ */}
                              </>
                            )}
                          </div>
                        </div>
                        {[...task?.task_comment]
                          ?.reverse()
                          ?.filter((c) => !c.parent_comment_id)
                          .map((comment, index) => (
                            <React.Fragment key={comment._id}>
                              <TaskComment
                                comment={comment}
                                onEdit={() => {}}
                                isEditing={editingCommentId === comment._id}
                                editingCommentId={editingCommentId}
                                onEditClick={handleEditClick}
                                onDelComment={onDelComment}
                                editCommentTitle={editCommentTitle}
                                setEditCommentTitle={setEditCommentTitle}
                                handleUpdateTaskComment={
                                  handleUpdateTaskComment
                                }
                                markCommentAsRead={markCommentAsRead}
                                selectedTask={task}
                                attachments={attachments || []}
                                onReplyComment={onReplyComment}
                                replyTarget={replyTarget}
                                setReplyTarget={setReplyTarget}
                                replyValues={replyValues}
                                setReplyValues={setReplyValues}
                                onSubmitReply={handleReplySubmit}
                                getReplyList={getReplyList}
                                sendingReply={sendingReply}
                                projectTeam={projectTeam}
                              />
                            </React.Fragment>
                          ))}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <Stack
                      spacing={1}
                      sx={{
                        padding: is_mobile_view
                          ? "0px 16px 8px 16px"
                          : "0px 16px 8px 8px",
                      }}
                    >
                      {/* Add checklist */}
                      <CheckList
                        canEditTask={canEditTask()}
                        task={task}
                        setTask={setTask}
                        setTasks={setTasks}
                        getTaskDetail={getTaskDetail}
                      />

                      <label htmlFor="icon-button-file">
                        <input
                          style={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          onChange={handleFileChange}
                          multiple
                          disabled={addFilesLoading || !canEditTask()}
                        />
                        <div
                          className="sidebar-button d-flex align-items-center"
                          id="attachment_sidebar_div"
                        >
                          Attachments
                          <IconButton
                            sx={{
                              bgcolor: (theme) => theme.palette.action.hover,
                            }}
                            onClick={() => {
                              document
                                .getElementById("attachment_sidebar_div")
                                .click();
                            }}
                          >
                            <Iconify
                              icon="grommet-icons:attachment"
                              sx={{ width: "1rem", height: "1rem" }}
                            />
                          </IconButton>
                          {addFilesLoading && (
                            <CircularProgress size={"15px"} />
                          )}
                        </div>
                      </label>
                      <div
                        className="sidebar-button d-flex align-items-center"
                        onClick={() => handleCopyTaskLink(task)}
                      >
                        Copy Task Link
                        <IconButton
                          sx={{
                            bgcolor: (theme) => theme.palette.action.hover,
                          }}
                          // size="small"
                        >
                          <Iconify
                            sx={{ width: "1rem", height: "1rem" }}
                            icon="clarity:copy-line"
                          />
                        </IconButton>
                      </div>
                      {canMoveTask &&
                        canEditTask() &&
                        (task?.role == "admin" || task?.role == "manager") && (
                          <div
                            className="sidebar-button d-flex align-items-center"
                            onClick={() =>
                              onMovetoWorkspace(task, task?.workspace.id)
                            }
                          >
                            Copy Task
                            <IconButton
                              sx={{
                                bgcolor: (theme) => theme.palette.action.hover,
                              }}
                              // size="small"
                            >
                              <Iconify
                                sx={{ width: "1rem", height: "1rem" }}
                                icon="material-symbols-light:move-down"
                              />
                            </IconButton>
                          </div>
                        )}

                      {canEditTask() && (
                        <div
                          className="sidebar-button d-flex align-items-center"
                          onClick={() => setModalRecurringEvent(true)}
                        >
                          Make it Recurring
                          <IconButton
                            sx={{
                              bgcolor: (theme) => theme.palette.action.hover,
                            }}
                          >
                            <Iconify
                              sx={{ width: "1rem", height: "1rem" }}
                              icon="streamline:fastforward-clock"
                            />
                          </IconButton>
                        </div>
                      )}
                      {/* --------------- Issue report --------------- */}
                      {canEditTask() &&
                        (task?.check_list?.some(
                          (checklist) => checklist.checklist_type === 1
                        ) ? (
                          <div
                            onClick={scrollToIssues}
                            className="sidebar-button d-flex align-items-center"
                          >
                            <div className="flex-column">
                              Reported Issues
                              <div className="mt-1">
                                {allResolved ? (
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ paddingLeft: "5px" }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "primary.main",
                                        fontWeight: 500,
                                        fontSize: "0.7rem",
                                        paddingRight: "4px",
                                      }}
                                    >
                                      <span className="pe-1 fw-bold">
                                        {
                                          task?.task_checklist_stats
                                            ?.issues_stats?.completed_count
                                        }{" "}
                                        /{" "}
                                        {
                                          task?.task_checklist_stats
                                            ?.issues_stats?.total_count
                                        }
                                      </span>
                                      Resolved
                                    </Typography>
                                    <Iconify
                                      color="primary.main"
                                      fontSize="12px"
                                      icon="icon-park-twotone:thumbs-up"
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ paddingLeft: "5px" }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "#e48e03",
                                        fontWeight: 500,
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      {
                                        task?.task_checklist_stats?.issues_stats
                                          ?.completed_count
                                      }
                                    </Typography>
                                    <Typography
                                      sx={{
                                        marginLeft: 0.5,
                                        marginRight: 0.75,
                                        fontWeight: 500,
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      /{" "}
                                      {
                                        task?.task_checklist_stats?.issues_stats
                                          ?.total_count
                                      }
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "0.7rem",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Issues Resolved
                                    </Typography>
                                  </div>
                                )}
                              </div>
                              <Button
                                size="small"
                                variant="outlined"
                                sx={{
                                  marginTop: "0.25rem",
                                  fontSize: "10px",
                                  padding: "0px 9px",
                                  borderRadius: "4px",
                                  color: "#e48e03",
                                  borderColor: "#ffad2873",
                                  minWidth: "auto",
                                  "&:hover": {
                                    borderColor: "#ffad2873",
                                    backgroundColor: "#f5a21d0f",
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenReportTaskIssueDialog(true);
                                }}
                              >
                                Report Issue
                              </Button>
                            </div>
                            <IconButton
                              sx={{
                                bgcolor: (theme) => theme.palette.action.hover,
                              }}
                            >
                              <Iconify
                                sx={{ width: "1rem", height: "1rem" }}
                                icon="ph:warning-duotone"
                                color="#e48e03"
                              />
                            </IconButton>
                          </div>
                        ) : (
                          <div
                            className="sidebar-button d-flex align-items-center"
                            onClick={() => setOpenReportTaskIssueDialog(true)}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            Report A Issue
                            <IconButton
                              sx={{
                                bgcolor: (theme) => theme.palette.action.hover,
                              }}
                            >
                              <Iconify
                                sx={{ width: "1rem", height: "1rem" }}
                                icon="ph:warning-duotone"
                                color="#e48e03"
                              />
                            </IconButton>
                          </div>
                        ))}
                      {/* --------------- FeedBack --------------- */}
                      {canEditTask() &&
                        (task?.check_list?.some(
                          (checklist) => checklist.checklist_type === 2
                        ) ? (
                          <div
                            onClick={scrollToFeedback}
                            className="sidebar-button d-flex align-items-center"
                          >
                            <div className="flex-column">
                              Feedbacks
                              <div className="mt-1">
                                {all_feedback_resolved ? (
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ paddingLeft: "5px" }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "primary.main",
                                        fontWeight: 500,
                                        fontSize: "0.7rem",
                                        paddingRight: "4px",
                                      }}
                                    >
                                      <span className="pe-1 fw-bold">
                                        {
                                          task?.task_checklist_stats
                                            ?.improvements_stats
                                            ?.completed_count
                                        }{" "}
                                        /{" "}
                                        {
                                          task?.task_checklist_stats
                                            ?.improvements_stats?.total_count
                                        }
                                      </span>
                                      Implemented
                                    </Typography>
                                    <Iconify
                                      color="primary.main"
                                      fontSize="12px"
                                      icon="icon-park-twotone:thumbs-up"
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ paddingLeft: "5px" }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "#1890FF",
                                        fontWeight: 500,
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      {
                                        task?.task_checklist_stats
                                          ?.improvements_stats?.completed_count
                                      }
                                    </Typography>
                                    <Typography
                                      sx={{
                                        marginLeft: 0.5,
                                        marginRight: 0.75,
                                        fontWeight: 500,
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      /{" "}
                                      {
                                        task?.task_checklist_stats
                                          ?.improvements_stats?.total_count
                                      }
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "0.7rem",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Implemented
                                    </Typography>
                                  </div>
                                )}
                              </div>
                              <Button
                                size="small"
                                variant="outlined"
                                sx={{
                                  marginTop: "0.25rem",
                                  fontSize: "10px",
                                  padding: "0px 9px",
                                  borderRadius: "4px",
                                  color: "#1890FF",
                                  borderColor: "#58aeff75",
                                  minWidth: "auto",
                                  "&:hover": {
                                    borderColor: "#58aeff75",
                                    backgroundColor: "#45c9fd0d",
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenImprovementDialog(true);
                                }}
                              >
                                Add feedback
                              </Button>
                            </div>
                            <IconButton
                              sx={{
                                bgcolor: (theme) => theme.palette.action.hover,
                              }}
                            >
                              <Iconify
                                sx={{ width: "1rem", height: "1rem" }}
                                icon="codicon:feedback"
                                color="#1890FF"
                              />
                            </IconButton>
                          </div>
                        ) : (
                          <div
                            className="sidebar-button d-flex align-items-center"
                            onClick={() => setOpenImprovementDialog(true)}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            Add Feedback
                            <IconButton
                              sx={{
                                bgcolor: (theme) => theme.palette.action.hover,
                              }}
                            >
                              <Iconify
                                sx={{ width: "1rem", height: "1rem" }}
                                icon="codicon:feedback"
                                color="#1890FF"
                              />
                            </IconButton>
                          </div>
                        ))}

                      {canEditTask() && (
                        <div
                          className="sidebar-button d-flex align-items-center"
                          style={{ color: "#bf2626" }}
                          onClick={onDelTask}
                        >
                          Delete Task
                          <IconButton
                            sx={{
                              bgcolor: (theme) => theme.palette.action.hover,
                            }}

                            // size="small"
                          >
                            <Iconify
                              sx={{ width: "1rem", height: "1rem" }}
                              icon="mingcute:delete-line"
                              color="#bf2626"
                            />
                          </IconButton>
                        </div>
                      )}
                    </Stack>
                    {/* ------------- Activity ------------- */}
                    <Activity task={task} />
                    {/* ------------------------------------- */}
                  </Grid>
                  <LabelDialog
                    projectId={task?.project?.id}
                    projectTags={projectTags}
                    setProjectTags={setProjectTags}
                    onChangeTags={onChangeTags}
                    task={task}
                    sections={sections}
                    getFilteredTasksBySection={getFilteredTasksBySection}
                    getListing={getListing}
                    openDialog={openLabelDialog}
                    closeDialog={closeLabelDialog}
                    dialogOpen={labelDialogOpen}
                    setDialogOpen={setDialogLabelOpen}
                    setSelectedTask={setTask}
                  />
                </Grid>
              </div>
            )}
          </DialogContent>
        )}
      </Dialog>

      {/* Recurring Event Dialog -----------------------------------  */}
      <RecurringEventDialog
        open={modalRecurringEvent}
        setOpen={setModalRecurringEvent}
        selectedDate={new Date()} //Today's date
        task={task}
      />
      {/* --------------- Issue report dialog --------------- */}
      <ReportTaskIssueDialog
        open={openReportTaskIssueDialog}
        setOpen={setOpenReportTaskIssueDialog}
        task={task}
        setTask={setTask}
        setTasks={setTasks}
      />
      {/* --------------- FeedBack dialog --------------- */}

      <ImprovementDialog
        open={openImprovementDialog}
        setOpen={setOpenImprovementDialog}
        task={task}
        setTask={setTask}
        setTasks={setTasks}
      />
      {/* ----------------------------------------------------------- */}
    </>
  );
}

export default TaskDetailDialog;
